import React from 'react';
import {BreakpointProvider} from '@/chakra/BreakpointProvider';
import {Outlet, ScrollRestoration} from 'react-router-dom';
import {Footer} from '../orga/Footer';
import NiceModal from '@ebay/nice-modal-react';

/**
 * Composant pour l'application Catalogue Grand Compte
 */
export const CatalogueGrandCompteApp: React.FC = () => {
  return (
    <BreakpointProvider>
      <NiceModal.Provider>
        <ScrollRestoration />
        <Outlet />
        <Footer grand_compte={true} />
      </NiceModal.Provider>
    </BreakpointProvider>
  );
};
